import {Component, OnInit} from '@angular/core';
import {IonApp, IonRouterOutlet, ModalController, MenuController} from '@ionic/angular/standalone';
import {VersionCheckerService} from "./core/utilities/version-checker.service";
import {NetworkService} from "./core/utilities/network.service";
import {SideMenuComponent} from "./components/shared/side-menu/side-menu.component";
import {Router, NavigationStart, NavigationEnd, ActivatedRoute} from '@angular/router';
import {filter} from 'rxjs/operators';
import { addIcons } from 'ionicons';
import { SeoService } from './core/services/seo.service';
import { 
  checkmarkCircle, 
  alertCircle, 
  warning, 
  informationCircle, 
  helpCircle,
  close
} from 'ionicons/icons';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, SideMenuComponent],
  standalone: true
})
export class AppComponent implements OnInit {

  constructor(
    private versionChecker: VersionCheckerService, 
    private networkService: NetworkService,
    private router: Router,
    private modalController: ModalController,
    private menuController: MenuController,
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute
  ) {
    addIcons({
      'checkmark-circle': checkmarkCircle,
      'alert-circle': alertCircle,
      'warning': warning,
      'information-circle': informationCircle,
      'help-circle': helpCircle,
      'close': close
    });
  }

  ngOnInit() {
    this.versionChecker.startVersionCheck();

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(async () => {
      await this.menuController.close('side');

      let topModal = await this.modalController.getTop();
      while (topModal) {
        await this.modalController.dismiss();
        topModal = await this.modalController.getTop();
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      let rt = this.activatedRoute;
      while (rt.firstChild) {
        rt = rt.firstChild;
      }
      rt.data.subscribe(data => {
        const title = (rt.snapshot.title as string) || 'Story Lounge | Café & Lounge à Sfax';
        this.seoService.updateTags({
          title: title,
          description: data['description'] || 'Story Lounge - Votre café lounge à Sfax.',
          image: data['image'] || 'assets/screenshots/screenshot-desktop-home-1280x720.png',
          url: window.location.href
        });
      });
    });
  }
}
